module.exports = __webpack_public_path__ + "static/media/DCA.1fc10cef.pdf";